import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Animations {
    constructor(){
        this.trigger = {
            banner: document.querySelector('body'),
        }
        this.animations = {
            banner_emotional: document.querySelectorAll('.banner-emotional img'),
        }
    }

    init(){
        
        this.set();
        this.animation();
   
    }

    set = () => {
        if (this.animations.banner_emotional){
            gsap.set(this.animations.banner_emotional, {
                y : 0,
            })
        };
    }

    animation = () => {
        if (window.innerWidth > 992) {
            if (this.animations.banner_emotional){
                gsap.to(this.animations.banner_emotional, {
                    y : -((document.querySelector('.banner-emotional img').offsetHeight) - (document.querySelector('.banner-emotional').offsetHeight)),
                    autoAlpha: 1,
                    scrollTrigger: {
                        trigger: this.animations.banner_emotional,
                        start: 'top-=20% center',
                        end: 'bottom center',
                        scrub: 0.5,
                        // once: true,
                        // markers: true,
                    }   
                })
            };
        }
    }
} 